(function () {
  let count = localStorage.getItem('windowCount') 
  count = count ? JSON.parse(count) : 0
  let refresh = sessionStorage.getItem('refresh')
  let forceNotClear = localStorage.getItem('forceNotClear')
  if (count <= 0 && !refresh && !forceNotClear) localStorage.clear()
})()

// Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './lib/polyfills'
import 'whatwg-fetch'

// Courtesty of webpack loader, we can load our global styles here
/* eslint-disable */
import './assets/styles/globals.scss'
/* eslint-disable */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue'
import router from './router'
import store from './store/index'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

// Commonly used components
import FormError from '@/components/FormError'
import FormErrorAlert from '@/components/FormErrorAlert'
import ICEAlert from '@/components/ICEAlert'
import { globalError } from './lib/utils'
import { auth } from './lib/plugins/authorization'
import App from './App.vue'

const app = createApp(App);

app.use(router)
app.use(store)

app.config.globalProperties.$auth = auth

// load FontAwesome libraries
library.add(far, fas);
app.component('FontAwesomeIcon', FontAwesomeIcon)

app.component('FormError', FormError)
app.component('FormErrorAlert', FormErrorAlert)
app.component('ICEAlert', ICEAlert)
 
app.mixin({
  computed: {
    printable() {
      return this.$route.query.print && JSON.parse(this.$route.query.print)
    },
  },
})

app.mount('#app')

if (window.localStorage.getItem('idToken'))
  store.dispatch('account/retrieveInfo')

store.dispatch('loadAnnouncement')

// Track window counts to kill the session when it is finished
if (!localStorage.getItem('windowCount')) {
  localStorage.setItem('windowCount', 1)
} else {
  let count = JSON.parse(localStorage.getItem('windowCount'))
  localStorage.setItem('windowCount', count + 1)
}

window.addEventListener('unload', () => {
  let count = JSON.parse(localStorage.getItem('windowCount') || 1)
  localStorage.setItem('windowCount', count - 1)
})

window.sessionStorage.setItem('refresh', true)

// Look for an error that is set to survive refresh.
;(() => {
  let refreshError = window.localStorage.getItem('refreshError')
  if (!refreshError) return
  refreshError = JSON.parse(refreshError)
  globalError(null, refreshError)
  window.localStorage.removeItem('refreshError')
})()

